import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white shadow-lg' 
          : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
         {/*  <div 
            className="flex items-center cursor-pointer"
            onClick={() => scrollToSection('hero')}
          >
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-to-br from-[#204FA7] to-[#1CA1CC] rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">RC</span>
              </div>
              <div>
                <h1 className="text-xl font-bold text-[#204FA7]">Rapide Colis</h1>
                <p className="text-xs text-gray-600">Paris ↔ Abidjan</p>
              </div>
            </div>
          </div> */}
          {/* Logo */}
        <div 
          className="flex items-center cursor-pointer"
          onClick={() => scrollToSection('hero')}
        >
          <div className="flex items-center space-x-2">
            
            {/* Image logo */}
            <img 
              src="https://app.rapidecolisexpress.com/logor.png" 
              alt="Rapide Colis Logo"
              className="w-20 h-20 object-contain rounded-lg"
            />

            {/* Texte */}
            <div>
              <h1 className="text-xl font-bold text-[#204FA7] uppercase ">  Rapide Colis</h1> 
              <p className="text-xs text-gray-600">Paris ↔ Abidjan</p>
            </div>

          </div>
        </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('hero')}
              className="text-gray-700 hover:text-[#204FA7] transition-colors font-medium"
            >
              Accueil
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-[#204FA7] transition-colors font-medium"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('tracking')}
              className="text-gray-700 hover:text-[#204FA7] transition-colors font-medium"
            >
              Suivi colis
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-[#204FA7] transition-colors font-medium"
            >
              Contact
            </button>
            <a 
                href="https://app.rapidecolisexpress.com/package/track"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#204FA7] text-white px-6 py-2.5 rounded-lg hover:bg-[#1a3f87] transition-colors font-medium shadow-md hover:shadow-lg inline-block"
              >
                Suivre mon colis
              </a>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200 bg-white">
            <nav className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('hero')}
                className="text-gray-700 hover:text-[#204FA7] transition-colors font-medium text-left"
              >
                Accueil
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-[#204FA7] transition-colors font-medium text-left"
              >
                Services
              </button>
              <a 
                href="https://app.rapidecolisexpress.com/package/track"
                target="_blank"
                className="text-gray-700 hover:text-[#204FA7] transition-colors font-medium text-left"
              >
                Suivi colis
              </a>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-[#204FA7] transition-colors font-medium text-left"
              >
                Contact
              </button>
              <a 
                href="https://app.rapidecolisexpress.com/package/track"
                target="_blank"
                className="bg-[#204FA7] text-white px-6 py-2.5 rounded-lg hover:bg-[#1a3f87] transition-colors font-medium text-left"
              >
                Suivre mon colis
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
